// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__zLy_u","dragIcon":"SortableItem_dragIcon__2UJhJ","disabled":"SortableItem_disabled__1F_2b"};